import { render, staticRenderFns } from "./ModuleViewer.vue?vue&type=template&id=0ca0f904&scoped=true"
import script from "./ModuleViewer.vue?vue&type=script&lang=js"
export * from "./ModuleViewer.vue?vue&type=script&lang=js"
import style0 from "./ModuleViewer.vue?vue&type=style&index=0&id=0ca0f904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0f904",
  null
  
)

export default component.exports